import * as yup from 'yup';
import yupJalaliDate from './jalaliDate';
import yupPassword from './password';
import yupMobile from './mobile';
import yupTelephone from './telephone';
import yupNationalId from './nationalId';
import yupLegalId from './legalId';
import yupSheba from './sheba';
import yupEnglishNumeric from './englishNumeric';


yupPassword(yup) // extend yup
yupMobile(yup) // extend yup
yupTelephone(yup) // extend yup
yupNationalId(yup) // extend yup
yupLegalId(yup) // extend yup
yupSheba(yup) // extend yup
yupEnglishNumeric(yup) // extend yup

// export default yup;

export { yupJalaliDate, yup };